import { decodeGS1 } from './gs1Decoder';

/**
 * Keep operational decisions here so a later client policy change does not
 * require changes to scanner capture, parsing, or the allocation modal.
 */
export const GS1_ALLOCATION_POLICY = Object.freeze({
  shortDatedMonths: 3,
  preferSerial: true,
  blockExpired: false,
  blockWrongGtin: false,
});

export function classifyExpiry(expiry, now = new Date(), shortDatedMonths = GS1_ALLOCATION_POLICY.shortDatedMonths) {
  if (!expiry) return { state: 'none', daysLeft: null };

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const expiryDate = new Date(expiry.year, expiry.month - 1, expiry.day);
  const daysLeft = Math.round((expiryDate - today) / 86400000);
  const shortLimit = new Date(
    today.getFullYear(),
    today.getMonth() + shortDatedMonths,
    today.getDate(),
  );

  if (expiryDate < today) return { state: 'expired', daysLeft };
  if (expiryDate <= shortLimit) return { state: 'short', daysLeft };
  return { state: 'ok', daysLeft };
}

export function evaluateAllocationScan(raw, expectedGtin, now = new Date(), policy = GS1_ALLOCATION_POLICY) {
  const decoded = decodeGS1(raw);
  const value = policy.preferSerial
    ? (decoded.serial || decoded.lot)
    : (decoded.lot || decoded.serial);
  const valueKind = decoded.serial && value === decoded.serial ? 'Serial' : 'LOT';
  const expiry = classifyExpiry(decoded.expiry, now, policy.shortDatedMonths);
  const gtinMatches = !!decoded.gtin && !!expectedGtin && decoded.gtin === expectedGtin;
  const unreadable = !decoded.ok && !decoded.gtin && !decoded.lot && !decoded.serial;
  const wrongGtin = !gtinMatches;
  const blocked = (
    (policy.blockExpired && expiry.state === 'expired')
    || (policy.blockWrongGtin && wrongGtin)
  );

  return {
    decoded,
    value: value || null,
    valueKind,
    expiry,
    gtinMatches,
    wrongGtin,
    unreadable,
    blocked,
  };
}
